import React from 'react';

import shared from 'src/styles/custom/Shared.module.scss';

import ValuationProduct from '../../../ValuationProduct';

const ProductsList = ({ pageData, productClasses }) => {
  return (
    <>
      {pageData?.categories.map((category) => (
        <div
          className={shared.tableCategory}
          key={category.id}
        >
          <h3 className={shared.tableCategoryTitle}>{category.name}</h3>
          {category.products.map((product) => (
            <ValuationProduct
              product={product}
              key={product.id}
              className={productClasses}
            />
          ))}
        </div>
      ))}
    </>
  );
};

export default ProductsList;
